module.exports = __webpack_public_path__ + "static/media/ja.d6ec7224.png";